import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { featureFlags } from 'src/app/featureFlags';
import { GeolocationService } from 'src/core';

@Injectable()
export class GeolocationInterceptor implements HttpInterceptor {
  constructor(private readonly geolocationService: GeolocationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      !featureFlags.enableGeolocationOperations.isEnabled() ||
      request.method !== 'POST'
    ) {
      return next.handle(request);
    }

    const shouldAppendGeolocationHeaders =
      endpointsWithGeolocation.some((e: string) => request.url.includes(e)) ||
      transferRouteRegExp.test(request.url) ||
      tradingUsaOrderRegExp.test(request.url);

    if (!shouldAppendGeolocationHeaders) {
      return next.handle(request);
    }

    const position = this.geolocationService.position$.getValue();

    if (!position) {
      return next.handle(request);
    }

    const {
      coords: { latitude, longitude },
    } = position;

    const updatedRequest = request.clone({
      setHeaders: {
        'device-latitude': `${latitude}`,
        'device-longitude': `${longitude}`,
      },
    });

    return next.handle(updatedRequest);
  }
}

/**
 * These are the endpoints that should have the position headers.
 */
const endpointsWithGeolocation = [
  // Withdrawals
  'Operation/RegisterWithdrawal',
  // Funds and Capital buy/sell orders
  'Operation/RegisterFundsOrder',
  'Operation/RegisterCapitalOrder',
];

/**
 * Transfers
 *
 * This should match routes like "contracts/:uuid/accounts/:uuid/transfers"
 *
 * "[^/]" will match **1 or more** chars that **are not** "/"
 * "\/" will match "/"
 */
const transferRouteRegExp = /contracts\/[^/]+\/accounts\/[^/]+\/transfers/;
const tradingUsaOrderRegExp =
  /orders\/contracts\/[^/]+\/accounts\/[^/]+\/orders/;
